import './CookiesAgreement/CookiesAgreement';
import './Collapse/Collapse';
import './LitPopupElement/LitPopupElement';
import { Tabs } from './Tabs/Tabs';

customElements.define('app-tabs', Tabs);